import { useMutation } from '@tanstack/react-query';

import useApi from '../use-api';

import type { IUpdateClinicInvoiceInfo } from 'infrastructure/interfaces';

const api = `core-2/clinics/invoices-info`;

export const useUpdateClinicInvoicesInfo = () => {
  const { updateData } = useApi();

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: async (data: IUpdateClinicInvoiceInfo) => {
      await updateData(api, data);
    },
  });

  return {
    mutateAsync,
    loading: isLoading,
  };
};
